
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { PeticaoArea } from '@app/models/peticao-area.model';

@Injectable()
export class PeticaoAreaService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(documento: PeticaoArea): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'peticao/areas', documento).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `peticao/areas/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `peticao/areas/${id}`);
  }

  obterTodos(): Observable<any> {
    return this.http.get(this.URL_API + 'peticao/areas');
  }

  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `peticao/areas/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

}
